import { Component, Vue } from 'vue-property-decorator';
import { TypeField, RegistrationField } from '@/types/Login';
import { AppModule } from '@/store/modules/app';
import { getCaptchaVerify } from '@/api/Auth';

@Component
export default class extends Vue {
  typeField = TypeField;

  regField = RegistrationField;

  isRecaptchaError = false;

  get applicantRegistrationFields() {
    return AppModule.setting?.login_tabs?.applicant_registration_fields || [];
  }

  get companyRegistrationFields() {
    return AppModule.setting?.login_tabs?.company_registration_fields || [];
  }

  public get isOnlyAbaSids() {
    return AppModule.sid.startsWith('abatest') || AppModule.sid.startsWith('abaooe') || AppModule.sid.startsWith('aba'); // for now only for abatest and abaooe
  }

  isField(type: TypeField, name: string, fields: any[]) {
    if (fields?.length) {
      const field = fields.find((x: any) => x.name === name);
      return field ? field[type] : false;
    }
    return false;
  }

  isApplicantField(type: TypeField, name: RegistrationField | string) {
    return this.isField(type, name, this.applicantRegistrationFields);
  }

  isCompanyField(type: TypeField, name: RegistrationField | string) {
    return this.isField(type, name, this.companyRegistrationFields);
  }
}
